import { render, staticRenderFns } from "./collectionRecord.vue?vue&type=template&id=388d8048&scoped=true"
import script from "./collectionRecord.vue?vue&type=script&lang=js"
export * from "./collectionRecord.vue?vue&type=script&lang=js"
import style0 from "./collectionRecord.vue?vue&type=style&index=0&id=388d8048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d8048",
  null
  
)

export default component.exports